























































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import qs from "qs";
import pinyin from "pinyin";
import moment from "moment";

import {
  Button,
  Uploader,
  Form,
  Field,
  RadioGroup,
  Radio,
  Popup,
  DatetimePicker,
  Area
} from "vant";
import customField from "@/components/customField/index.vue";
import { formatDate } from "@/utils/date";
import { isIdCard } from "@/utils/verify";
import IDCardUpload from "./IDCardUpload.vue"
// import {} from "";

const createAccountModule = namespace("createAccount");
const commonModule = namespace("common");
const failReasonModule = namespace("failReason");

@Component({
  name: "IDCardVerify",
  components: {
    [Uploader.name]: Uploader,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Area.name]: Area,
    [customField.name]: customField
  }
})
export default class IDCardVerify extends Vue {
  @createAccountModule.Getter("open_mode_info") open_mode_info: any;
  @createAccountModule.Getter("id_card_ocr_info") id_card_ocr_info: any;
  @createAccountModule.Getter("currentCountry") getterCurrentCountry: any;
  @createAccountModule.Mutation("SAVE_ID_CARD_OCR_INFO") saveIDCardOcrInfo: any;
  @createAccountModule.Mutation("SAVE_W8BEN_INFO") saveW8benInfo: any;
  @commonModule.Mutation("SAVE_NAV_TITLE") saveNavTitle: any;
  @failReasonModule.Mutation("SAVE_MODIFIED_FAIL_REASON")
  saveModifiedFailReason: any;

  form:any = {
    real_name: "",
    english_name: "",
    sex: 1,
    birth: "",
    id_card: "",
    termination: "1993-10-01",
    id_type: 1, //身份证1 护照2 驾驶证3 州身份证4,
  };

  accountOpenObject = {
  	birth:""
  }

  pickerType = 1; // 1 设置年月日 2 设置有效期开始时间 3 设置有效期结束时间

  chinaForm = {
    detail_address: "",
    country_name: "",
    country_code: "",
    city_name: "",
    city_code: "",
    province_name: "",
    province_code: ""
  };

  hkForm = {
    nationality_code: "",
    nationality_name: ""
  };

  showBirthPicker = false;

  currentDate = new Date();

  showAddressPicker = false;
  areaList = {};
  enAreaList = {
    province_list: {},
    city_list: {},
    county_list: {}
  };
  isLoadingAddress = true;

  isErrorShow = true

  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  get minDate(){
      let date = new Date();
      let y = date.getFullYear() - 100
      return new Date(y + '/' + '1/1');
  }
  get maxDate(){
    let date = new Date();
    let y = date.getFullYear() + 100
    return new Date(y + '/' + '1/1');
  }
  get addressText() {
    if (this.chinaForm.province_name) {
      return (
        this.chinaForm.province_name +
        this.chinaForm.city_name +
        this.chinaForm.country_name
      );
    } else {
      return "";
    }
  }

  get computedEnglishNameLabel() {
    return this.isHK
      ? this.$t("open_account.idcard_verify.english_name_field.label1")
      : this.$t("open_account.idcard_verify.english_name_field.label2");
  }

  get isHK() {
    return this.open_mode_info.open_status == "2";
  }




  get isSubmitDisabled() {
    const disabled1 = Object.keys(this.form).some(item => {
      return !this.form[item];
    });
    // const disabled2 = !this.chinaForm.detail_address || !this.addressText;
    const disabled3 = !this.hkForm.nationality_name;
    if (this.isHK) {
      return disabled1 || disabled3;
    } else {
      return disabled1;
    }
  }

  // get submitBtnText() {
  //   return this.open_mode_info.open_status == 1 ? "";
  // }

  // @Watch("open_mode_info", { deep: true, immediate: true })
  // watchOpenModeInfo(val) {
  //   const { open_status } = val;
  //   const navTitle: any =
  //     open_status == 1
  //       ? this.$t("open_account.idcard_verify.nav_title1")
  //       : this.$t("open_account.idcard_verify.nav_title2");
  //   document.title = navTitle;
  //   this.saveNavTitle(navTitle);
  // }

  @Watch("id_card_ocr_info", { deep: true, immediate: true })
  watchIdCardOcrInfo() {
    const { open_status } = this.open_mode_info;
    const { modify } = this.$route.query;
    if (open_status == "2" && !modify) return;
    const {
      real_name,
      english_name,
      sex,
      birth,
      id_card,
      detail_address,
      country_name,
      country_code,
      city_name,
      city_code,
      province_name,
      province_code,
      end_date,
      start_date
    } = (this as any).id_card_ocr_info;
    this.chinaForm = {
      detail_address,
      country_name,
      country_code,
      city_name,
      city_code,
      province_name,
      province_code
    };
    (this as any).form = { ...(this as any).form, real_name, english_name, sex, birth, id_card };
    if(this.open_mode_info.open_status == 1){
      (this as any).form = { ...(this as any).form, end_date:(end_date as any), start_date}
      // eslint-disable-next-line no-empty
    }else{

    }
  }

  activated() {
    const { id, name } = this.getterCurrentCountry;
    this.hkForm = {
      nationality_code: id,
      nationality_name: name
    };
  }

  // 校验香港证件号
  handvalidator(){
    if((this as any).open_mode_info.open_status == 1){
      if (!isIdCard((this as any).form.id_card)) {
        (this as any).isErrorShow = false
      }else{
        (this as any).isErrorShow = true
      }
    }else{
      if(!(this as any).form.id_card){
        (this as any).isErrorShow = true
      }
      if(!/^[a-zA-Z0-9]+$/.test((this as any).form.id_card) && (this as any).form.id_card){
        (this as any).isErrorShow = false
      }else{
        (this as any).isErrorShow = true
      }
    }
  }


  setNamePinyin(name) {
    const pinyinArr = pinyin(name, { style: pinyin.STYLE_NORMAL });
    const res = pinyinArr.map(item => {
      return item[0];
    });
    return res.join(" ");
  }

  openPicker(type){
    this.pickerType = type;
    this.showBirthPicker = true;
  }

  handleOpenBirthday() {
    const { pickerType } = this;
    this.currentDate = this.form[pickerType] == "" ? new Date() : new Date(this.form[pickerType]);
  }

  handleConfirmBirth(date) {
    const { pickerType } = this;
    this.form[pickerType] = formatDate(date, "yyyy-MM-dd");
    this.showBirthPicker = false;
  }

  handleOpenAddressPicker() {
    if (Object.keys(this.areaList).length !== 0) {
      return;
    }
    //获得省市区json
    (this as any).$apis
      .getAddressLists()
      .then(res => {
        const { en, zh } = res;
        this.areaList = zh;
        this.enAreaList = en;
        this.isLoadingAddress = false;
      })
      .catch(e => {
        
      });
  }

  handleSetAddress(arr) {
    
    this.chinaForm.province_name = arr[0] ? arr[0].name : "";
    this.chinaForm.province_code = arr[0] ? arr[0].code : "";
    this.chinaForm.city_name = arr[1] ? arr[1].name : "";
    this.chinaForm.city_code = arr[1] ? arr[1].code : "";
    this.chinaForm.country_name = arr[2] ? arr[2].name : "";
    this.chinaForm.country_code = arr[2] ? arr[2].code : "";
    this.showAddressPicker = false;
  }

  translateAddressData(address) {
    const { province_code, city_code, country_code } = address;
    const { province_list, city_list, county_list } = this.enAreaList;
    const province_name = province_list[province_code];
    const city_name = city_list[city_code];
    const country_name = county_list[country_code];
    return {
      province_name,
      province_code,
      city_name,
      city_code,
      country_name,
      country_code
    };
  }

  handleSubmitIdCardInfo() {
    const { open_type, modify } = this.$route.query;
    const { open_status } = this.open_mode_info;
    if (open_status == "1") {
      if (!isIdCard(this.form.id_card)) {
        return this.$toast.fail((this as any).$t('error_cn_tips'));
      }
    } else {
      if (this.form.id_card.length < 6) {
        return this.$toast.fail((this as any).$t('error_hk_tips'));
      }
    }

    (this as any).$apis
      .saveIdCardInfo({
        ...this.form,
        ...this.chinaForm,
        ...this.hkForm,
        birth: moment(this.form.birth).format("YYYYMMDD"),
        type: modify ? 1 : 0,
        card_term_start: this.form.start_date,
        card_term_end: this.form.end_date
      })
      .then(() => {
        // if (end_path == this.$route.name) {
        //   return this.$router.push("/modify-result");
        // }
		this.accountOpenObject.birth = moment(this.form.birth).format("YYYY")
		window.localStorage.setItem("accountOpenObject", JSON.stringify(this.accountOpenObject))
        if (modify == "1") {
          this.saveModifiedFailReason(1);
          this.$router.go(-2);
        } else {
          const { real_name, english_name, sex, birth, id_card } = this.form;
          const {
            detail_address,
            country_name,
            country_code,
            city_name,
            city_code,
            province_name,
            province_code
          } = this.chinaForm;
          const { nationality_code, nationality_name } = this.hkForm;
          let newDate:any = {
            real_name,
            english_name,
            sex,
            birth,
            id_card,
            detail_address,
            country_name,
            country_code,
            city_name,
            city_code,
            province_name,
            province_code,
            nationality_code,
            nationality_name,
          };
          if(this.open_mode_info.open_status == 1 ){
            newDate = {
              ...newDate,
              end_date: this.form["end_date"],
              start_date: this.form["start_date"]
            }
          }

          this.saveIDCardOcrInfo(newDate);
		  this.$router.push({
        path: "/address-proof",
        query: this.$route.query
      });
          // if (this.isHK) {
          //   this.$router.push("/address-proof");
          // } else {
          //   const address = this.translateAddressData(this.chinaForm);
          //   this.saveW8benInfo({ ...address });
          //   if (open_type == "1") {
          //     this.$router.push({
          //       path: "/face-record",
          //       query: this.$route.query
          //     });
          //   } else {
          //     this.postFaceInfo();
          //   }
          // }
        }
      })
      .catch(e => {
        
      });
  }

  postFaceInfo() {
    (this as any).$apis
      .postFaceInfo({
        card_no: this.form.id_card,
        name: this.form.real_name
      })
      .then(res => {
        const {
          wbappid,
          version,
          nonce,
          orderNo,
          h5faceId,
          userId,
          sign
        } = res;
        const callBackUrl =
          window.location.protocol +
          "//" +
          window.location.host +
          "/face-result";
        const faceParams = {
          webankAppId: wbappid,
          version,
          nonce,
          orderNo,
          h5faceId,
          userId,
          sign,
          url: encodeURI(callBackUrl),
          resultType: "1",
          from: "browser"
        };
        window.location.href =
          "https://ida.webank.com/api/web/login?" + qs.stringify(faceParams);
      })
      .catch(e => {
        
      });
  }
}
